export type ExchangePeriodHoursType = {
  morning: [number, number];
  afternoon: [number, number];
  night: [number, number];
};

export const DefaultExchangePeriodHours: ExchangePeriodHoursType = {
  morning: [8, 0],
  afternoon: [17, 0],
  night: [22, 0],
};
